module.exports = __webpack_public_path__ + "static/media/builtinv2-rosetki.2f41463f.png";